import getFormattedDollarPrice from 'shared/getters/getFormattedDollarPrice';

export function formatLowestPrice(price: number | undefined, widgetStepPricePre: string) {
  if (!price) {
    return undefined;
  }

  return `${widgetStepPricePre} ${getFormattedDollarPrice(price)}`;
}
